import { Recurso } from '../model/recurso.model';
import { HttpClient, HttpStatusCode } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { environment } from "src/environments/environment";
import { ApiErrorHandlerService } from "./api-error-handler.service";
import { Observable, catchError } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class RecursoService {

    private readonly baseUrl = `${environment.apiUrl}/lud`;
    private readonly noMsgsFor = [HttpStatusCode.InternalServerError];

    constructor(
        private readonly http: HttpClient,
        private readonly errorHandler: ApiErrorHandlerService
    ) { }

    salvarRecurso(recurso: Recurso): Observable<Recurso> {
        const url = `${this.baseUrl}/recurso/create`;
        return this.http.post<Recurso>(url, recurso).pipe(catchError(this.errorHandler.handle(this.noMsgsFor)));
    }

    listarRecursos(): Observable<Recurso[]> {
        const url = `${this.baseUrl}/recurso/listar`;
        return this.http.get<Recurso[]>(url).pipe(catchError(this.errorHandler.handle(this.noMsgsFor)));
    }

    buscarRecurso(idRecurso: number): Observable<Recurso> {
        const url = `${this.baseUrl}/recurso/${idRecurso}`;
        return this.http.get<Recurso>(url).pipe(catchError(this.errorHandler.handle(this.noMsgsFor)));
    }

    atualizarRecurso(idRecurso: number, recurso: Recurso): Observable<Recurso> {
        const url = `${this.baseUrl}/recurso/${idRecurso}`;
        return this.http.put<Recurso>(url, recurso).pipe(catchError(this.errorHandler.handle(this.noMsgsFor)));
    }

    deletarRecurso(idRecurso: number) {
        const url = `${this.baseUrl}/recurso/${idRecurso}`;
        return this.http.delete<number>(url).pipe(catchError(this.errorHandler.handle(this.noMsgsFor)));
    }
}